<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">인사말씀<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="sub01_wrap">
          <div class="box01">
            <figure>
              <img
                src="@/assets/img_up/shop_pds/kp708/design/img/subimg1.jpg"
                alt="인사말"
              />
              <span>대표이사 강정하</span>
            </figure>
            <div>
              <p>
                새 시대가 미지의 꿈을 품고 상상을 초월하는 모습으로 우리 삶의 한
                가운데 자리잡고 있습니다. 미래는 삶 전반을 더 파격적인 모습으로
                더 빠르게 바꾸어 가고 있습니다. 변화무쌍한 미래는 보통사람이
                창조성을 발휘하여 기회의 세상이 될 것입니다.
              </p>
              <p>
                창조성은 꿈을 품고 미래를 준비하는 사람에게 찾아오는 선물입니다.
                인간의 창조성은 개인이 유전자의 지시에 따라 발달 과업을 수행하는
                가운데, 다양한 경험을 쌓고 재능을 발휘하면서 성장, 발현합니다.
                성장기 학생의 창조성은 이따금씩 놀라운, 엉뚱한, 아직은 미성숙한
                불확실한 모습을 드러냅니다. 이러한 현상은 창조성의 일면을
                보여주는 증거입니다. 성장기 학생의 미미한 창조성은 보호자의
                세심한 관심과 보살핌으로 자랍니다.
              </p>
              <p>
                창조성은 개인이 세상을 향한 마음을 키우면서 만나는 특별한 경험의
                결실입니다. 경험은 마음이 세상과 연결됨으로써 특별해지며, 세상
                이해와 자기 이해를 발판으로 자아실현에 이르게 됩니다. 코코랩은
                성장기 학생들이 새로운 시대에 새로운 꿈을 품고 새로운 미래를
                준비하도록 돕기 위해 설립되었습니다. 코코랩은 성장기 학생들이
                미래를 기회로 만드는 확실성을 높일 수 있도록, 이에 최적화된 역량
                및 재능 시스템을 구축하는 노력을 지속해오고 있습니다. 코코랩은
                분야 최고 전문가들과 함께 하고 있습니다.
              </p>
              <br />
              <p style="text-align: center">2020년 2월</p>
              <h3><span>Ph. D</span> 강 정 하</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");
  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.box01 {
  position: relative;
  overflow: hidden;
}
.box01 figure {
  margin-bottom: 20px;
  text-align: center;
  width: 170px;
  margin: 0 auto 20px auto;
  display: none;
}
.box01 figure span {
  display: block;
  background: #fff;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  padding: 5px 0 0 0;
}
.sub01_wrap h1 {
  font-size: 17px;
  padding-top: 10px;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  position: relative;
}
.sub01_wrap h1:after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 50px;
  height: 2px;
  background: #00417e;
}
.sub01_wrap h2 {
  font-size: 17px;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 3px solid #00417e;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
}
.sub01_wrap p {
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 1.6em;
  color: #454545;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 400;
  word-break: keep-all;
  text-align: justify;
}
.sub01_wrap h3 {
  font-size: 16px;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  position: relative;
  padding-bottom: 50px;
  text-align: right;
}
.sub01_wrap h3 > span {
  padding-right: 10px;
}
@media screen and (min-width: 768px) {
  .box01 figure {
    margin: 0px auto 20px auto;
  }
  .sub01_wrap h1 {
    font-size: 19px;
  }
  .sub01_wrap h2 {
    font-size: 19px;
  }
  .sub01_wrap p {
    font-size: 16px;
  }
}
@media screen and (min-width: 1100px) {
  .box01 > div {
    border: 1px solid #eaeaea;
    padding: 70px 30px 20px 30px;
    box-sizing: border-box;
  }
  .box01 figure {
    position: absolute;
    top: 45px;
    left: 0;
    width: 120px;
    z-index: 99;
  }
}
</style>
